"use strict";
// tslint:disable:object-literal-sort-keys
var $dyn;
(function ($dyn) {
    var ui;
    (function (ui) {
        ui.defaults = {};
        /**
         * The base parent control.
         * All other control types should extend this.
         * @abstract
         *
         * @remarks For performance, we need to emphasize the clonability of controls. Add any code that would vary across
         *          clones (such as Value-dependent code) within the init function on the prototype. Statically declared
         *          functions should be placed directly in the prototype object. Also, do not reference anything outside of
         *          "this" within the init to avoid creating a closure that isn't clonable.
         * @remarks Note on keyDown behavior for the Enter key ($dyn.ui.KeyCodes.enter) for controls: If your
         *          control needs to handle the keyDown event on the Enter key for a specific purpose, such as keying down
         *          in a multiline text area, or typing Enter to close the quickfilter flyout, you will need to handle the
         *          Enter key to prevent propagation to the form level. Letting the Enter keyDown event propagate to the
         *          form will execute the form level Enter shortcut when the control is inside of a dialog. In certain
         *          cases, we do not want this shortcut to be executed, so we need to stopPropagation on the event so that
         *          it will not propagate to the form level. An example of this is in $dyn.controls.Button.keyDown.
         */
        var Control = /** @class */ (function () {
            function Control(data, element, parent, role) {
                this.ServiceBoundary = null;
                /**
                 * When updating LastSelectedControl on the server, this value is used instead of the control itself if it is set.
                 * @internal
                 */
                this.ServerFocusableControl = null;
                /** @internal */
                this.IsServerFocusable = (function () {
                    var isFocusable = true;
                    // tslint:disable-next-line:only-arrow-functions
                    return function (isFocusableParm) {
                        if (arguments.length > 0) {
                            isFocusable = isFocusableParm;
                        }
                        return isFocusable;
                    };
                })();
                this._role = role;
                this._parent = parent;
                this.focusCallback = this.focusCallback.bind(this);
                this.init(data, element);
            }
            Object.defineProperty(Control.prototype, "Id", {
                /**
                 * Element ID.
                 */
                get: function () {
                    if (this._id === undefined && this.element) {
                        this._id = this.element.getAttribute("id");
                    }
                    return this._id;
                },
                /**
                 * Do not use.
                 * @param newId The new ID.
                 */
                set: function (newId) {
                    newId = $dyn.value(newId);
                    /// #DEBUG
                    if (this._id && this._id !== newId) {
                        $dyn.logError("The id of a control can not be changed");
                    }
                    /// #ENDDEBUG
                    if (!this._id && this.element) {
                        this.element.setAttribute("id", $dyn.value(newId));
                    }
                    this._id = newId;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(Control.prototype, "Name", {
                /**
                 * Control name.
                 */
                get: function () {
                    if (this._name === undefined && this.element) {
                        this._name = this.element.getAttribute("data-dyn-controlname");
                    }
                    return this._name;
                },
                /**
                 * Do not use.
                 * @param newName The new control name.
                 */
                set: function (newName) {
                    newName = $dyn.value(newName);
                    /// #DEBUG
                    if (this._name && this._name !== newName) {
                        $dyn.logError("The name of the control scan not be changed");
                    }
                    /// #ENDDEBUG
                    if (!this._name && this.element) {
                        this.element.setAttribute("data-dyn-controlname", newName);
                    }
                    this._name = newName;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(Control.prototype, "LayoutWidth", {
                /**
                 * Layout width.
                 */
                get: function () {
                    if (!this._layoutWidth) {
                        this._layoutWidth = $dyn.ui.autoProperty($dyn.layout.Size.content, this, "Width");
                    }
                    return this._layoutWidth;
                },
                /**
                 * @param value The new layout width.
                 */
                set: function (value) {
                    this._layoutWidth = value;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(Control.prototype, "LayoutHeight", {
                /**
                 * Layout height.
                 */
                get: function () {
                    if (!this._layoutHeight) {
                        this._layoutHeight = $dyn.ui.autoProperty($dyn.layout.Size.content, this, "Height");
                    }
                    return this._layoutHeight;
                },
                /**
                 * @param value The new layout height.
                 */
                set: function (value) {
                    this._layoutHeight = value;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(Control.prototype, "IsDataBound", {
                /**
                 * Indicates if the control is data bound.
                 */
                get: function () {
                    return this._role && this._role.isDataBound;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(Control.prototype, "Children", {
                /**
                 * The control's child controls.
                 */
                get: function () {
                    return this._role && this._role.children;
                },
                /**
                 * Should only be used in test.
                 * @param value The new children.
                 */
                set: function (value) {
                    if (!this._role) {
                        this._role = {};
                    }
                    this._role.children = value;
                },
                enumerable: false,
                configurable: true
            });
            Object.defineProperty(Control.prototype, "Updating", {
                /**
                 * The updating observable.
                 */
                get: function () {
                    if (!this.__updating) {
                        this.createUpdatingObservable();
                    }
                    return this.__updating;
                },
                enumerable: false,
                configurable: true
            });
            Control.prototype.showShortcutsHandler = function (target) {
                var _this = this;
                if (this.shortcutToolTip) {
                    $(".shortcutHelp .viewAllShortcuts").click();
                }
                else {
                    var controlShortcuts_1 = $dyn.util.getShortcutsTextForControl(this, target);
                    if (this.qtipRepositionInterval) {
                        window.clearInterval(this.qtipRepositionInterval);
                        this.qtipRepositionInterval = null;
                    }
                    this.shortcutToolTip = $(target)
                        .qtip({
                        id: "shortcutToolTip",
                        content: {
                            text: function (event, api) {
                                var outerDiv = document.createElement("div");
                                if (controlShortcuts_1 && controlShortcuts_1[$dyn.ui.ShortcutCategory.ElementAction]) {
                                    var shortcutsList = document.createElement("div");
                                    shortcutsList.classList.add("shortcutsList");
                                    for (var i = 0, len = controlShortcuts_1[$dyn.ui.ShortcutCategory.ElementAction].length; i < len; i++) {
                                        var shortcut = controlShortcuts_1[$dyn.ui.ShortcutCategory.ElementAction][i];
                                        var innerDiv = document.createElement("div");
                                        innerDiv.classList.add("shortcutDiv");
                                        var descText = document.createElement("span");
                                        descText.classList.add("descriptionText");
                                        descText.textContent = shortcut.descriptionText;
                                        innerDiv.appendChild(descText);
                                        var keyText = document.createElement("span");
                                        keyText.classList.add("keyText");
                                        keyText.textContent = shortcut.keyText;
                                        innerDiv.appendChild(keyText);
                                        shortcutsList.appendChild(innerDiv);
                                    }
                                    outerDiv.appendChild(shortcutsList);
                                }
                                var viewAllLink = document.createElement("a");
                                viewAllLink.classList.add("viewAllShortcuts");
                                viewAllLink.href = "javascript:void(0)";
                                viewAllLink.textContent = "View all currently available shortcuts";
                                viewAllLink.onclick = function () {
                                    api.hide();
                                    $dyn.showAvailableShorcutsDialog($dyn.util.getAvailableShortcutsText(_this, target));
                                };
                                outerDiv.appendChild(viewAllLink);
                                return outerDiv;
                            },
                            title: $dyn.label("Framework_ElementActions"),
                        },
                        style: {
                            classes: "baseDirection fieldToolTipBase shortcutHelp",
                            tip: true,
                            width: "280px",
                        },
                        position: {
                            at: "center right",
                            effect: $dyn.flags.disableAnimations ? false : undefined,
                            my: "center left",
                            viewport: $(window),
                        },
                        show: {
                            delay: $dyn.flags.disableAnimations ? 0 : 500,
                            effect: $dyn.flags.disableAnimations ? false : undefined,
                            ready: true,
                        },
                        hide: {
                            effect: $dyn.flags.disableAnimations ? false : undefined,
                            event: "unfocus",
                            fixed: true,
                        },
                        events: {
                            focus: function (event, api) {
                                event.preventDefault(); // prevents other qtips from dismissing
                            },
                            hide: function (event, api) {
                                if (_this.shortcutToolTip) {
                                    _this.shortcutToolTip.destroy(true);
                                    _this.shortcutToolTip = null;
                                }
                                if (_this.qtipRepositionInterval) {
                                    window.clearInterval(_this.qtipRepositionInterval);
                                    _this.qtipRepositionInterval = null;
                                }
                            },
                            render: function (event, api) {
                                var escapeHandler = function (keyboardEvent) {
                                    if (keyboardEvent.keyCode === $dyn.ui.KeyCodes.esc) {
                                        document.removeEventListener("keydown", escapeHandler, true);
                                        keyboardEvent.stopPropagation();
                                        $dyn.log.stopPropagation && $dyn.log.stopPropagation("Escape handler for qtip");
                                        keyboardEvent.preventDefault();
                                        api.hide();
                                    }
                                };
                                document.addEventListener("keydown", escapeHandler, true);
                            },
                        },
                    })
                        .qtip("api");
                    if (this.shortcutToolTip) {
                        this.qtipRepositionInterval = window.setInterval(function () {
                            // Check if the element is visible
                            if ($dyn.value(_this.Visible)) {
                                _this.shortcutToolTip.reposition(null, true);
                            }
                        }, 500);
                    }
                }
            };
            /**
             * This is called upon creation of the control.
             */
            Control.prototype.init = function (data, element) {
                this.element = element;
                if (this.bindUpdate) {
                    // If bindUpdate is true this means the control supports updating handlers based on the updating flag, rather than observability.
                    this.bindingTrigger = $dyn.observable(0); // Indicate to the framework that a binding trigger will be used for propagating updates to handlers.
                }
                this.applyParameters(data);
            };
            /**
             * Keeps track of disposables that this control is using.
             */
            Control.prototype.usingDisposable = function (disposable) {
                if (!this._disposables) {
                    this._disposables = [];
                }
                this._disposables.push(disposable);
                return disposable;
            };
            /**
             * Disposes the disposables and clears the timeouts.
             */
            Control.prototype.dispose = function () {
                if (this._disposables) {
                    // tslint:disable-next-line:prefer-for-of
                    for (var i = 0; i < this._disposables.length; i++) {
                        this._disposables[i].dispose();
                    }
                    this._disposables = undefined;
                }
                if (this._timeoutIds) {
                    // tslint:disable-next-line:forin no-shadowed-variable
                    for (var i in this._timeoutIds) {
                        clearTimeout(this._timeoutIds[i]);
                    }
                    this._timeoutIds = undefined;
                }
            };
            /**
             * Used by Task Recorder to position the QTip during rails mode.
             */
            Control.prototype.getTaskGuideParams = function (options) {
                $.extend(options, {
                    adjustMethod: "flip",
                    at: $dyn.layout.qTipPosition.rightCenter,
                    my: $dyn.layout.qTipPosition.leftCenter,
                    target: $(this.element),
                });
                return options;
            };
            /**
             * Returns an array of Elements that make up the control. For example, tab pages will return both the header and content element.
             */
            Control.prototype.getPersonalizationElements = function () {
                return [this.element];
            };
            /**
             * Gets the list of context menu options for this control
             * @param targetElement The element to obtain the options from.
             * @returns An array of Objects, each representing an option in the context menu.
             */
            Control.prototype.getContextMenuOptions = function (targetElement) {
                var _this = this;
                return [
                    {
                        Label: $dyn.label("Framework_ViewShortcuts"),
                        Command: function () {
                            $dyn.showAvailableShorcutsDialog($dyn.util.getAvailableShortcutsText(_this, _this.element));
                        },
                    },
                ];
            };
            /**
             * Wrapper for $dyn.observe when given a specific property.
             * @param prop The property to observe
             * @param func Callback to fire when the property changes.
             */
            Control.prototype.observe = function (prop, func) {
                var self = this;
                /// #DEBUG
                if (!prop.observable) {
                    throw new TypeError("Property must be observable in order to observe it.");
                }
                /// #ENDDEBUG
                if (!$dyn.isObservable(self[prop.backingField])) {
                    // tslint:disable-next-line:no-unused-expression
                    self[prop.name]; // Access the field so the observable is created.
                }
                return $dyn.observe(self[prop.backingField], function (newValue) {
                    func(newValue);
                });
            };
            Control.prototype.setUpdating = function (value) {
                if (!this.__updating) {
                    this.createUpdatingObservable();
                }
                this.__updating(value);
            };
            Control.prototype.isInGrid = function () {
                if (this._isInGrid === undefined) {
                    var isInGrid = false;
                    var parent_1 = this.element;
                    while (parent_1 && parent_1.classList && !isInGrid) {
                        isInGrid = parent_1.classList.contains("listCellControl") || parent_1.classList.contains("listItem");
                        if (!isInGrid) {
                            parent_1 = parent_1.parentNode;
                        }
                    }
                    this._isInGrid = isInGrid;
                }
                return this._isInGrid;
            };
            Control.prototype.isInSelectedGridRow = function () {
                var isInSelectedRow = false;
                var parent = this.element;
                var isInGrid = false;
                while (parent && parent.classList && !isInGrid) {
                    isInGrid = parent.classList.contains("listItem");
                    if (!isInGrid) {
                        parent = parent.parentNode;
                    }
                    else {
                        var selectedAttribute = parent.getAttribute("data-dyn-row-active");
                        isInSelectedRow = $dyn.util.converters.booleanString(selectedAttribute);
                    }
                }
                return isInSelectedRow;
            };
            /**
             * Invoke the passed in callback in the context of an updating scope.
             * @remarks If we are already in an updating scope, then invoke the function as usual.
             */
            Control.prototype.updatingBlock = function (callback) {
                if (!this.parametersApplied || $dyn.peek(this.__updating)) {
                    callback.apply(this);
                    return;
                }
                this.setUpdating(true);
                callback.apply(this);
                this.setUpdating(false);
            };
            /**
             * AllowEdit && Enabled && Visible
             * @internal
             */
            Control.prototype.allowUserChanges = function () {
                return $dyn.value(this.AllowEdit) && $dyn.value(this.Enabled) && $dyn.value(this.Visible);
            };
            /**
             * Sets focus to this control.
             * @remarks This function is bound to the current object in the constructor
             * @internal
             */
            Control.prototype.focusCallback = function (options) {
                var element = options[0] ? options[0] : this.element;
                var controlElement = $(element)
                    .addBack()
                    .closest("[data-dyn-controlname]")[0];
                var controlName = controlElement ? controlElement.getAttribute("data-dyn-controlname") : "";
                $dyn.log.focus && $dyn.log.focus("Focus: Control->focusCallback - set focus to : %s", controlName);
                // Set focus to the control.
                $dyn.util.focusElement(element);
            };
            /**
             * Can override to provide initialization of cached DOM elements and computeds.
             */
            Control.prototype.attached = function () { };
            Control.prototype.applyParameters = function (data) {
                var property;
                var value;
                var self = this;
                // tslint:disable-next-line:forin
                for (property in data) {
                    value = data[property];
                    if (property === "DataSource") {
                        // TODO: Reconcile DataSource to be like any other property.
                        this.DataSource = data.DataSource;
                    }
                    if (property in self) {
                        if ($dyn.isObservable(self[property])) {
                            // The control property is not a default value, so use it value storage. Sometimes happens with computed values with setters.
                            value = $dyn.peek(value);
                            if (value !== undefined) {
                                self[property](value);
                            }
                        }
                        else {
                            if ($dyn.isObservable(value)) {
                                if (self.properties && self.properties[property]) {
                                    // Control has a getter/setter property, options is observable.
                                    // Serverform should not use this path. It is only for 'client' forms that are passing observables as control options.
                                    // tslint:disable-next-line:no-shadowed-variable
                                    (function (self, value, property) {
                                        // self executing function to avoid closure problem inside loop.
                                        self.usingDisposable($dyn.observe(value, function (newValue) {
                                            self[property] = newValue;
                                        }));
                                    })(self, value, property);
                                }
                                else {
                                    // Control has default value (default values are not observable), options is observable.  This is a typical case with server form.
                                    var observableValue = $dyn.peek(value);
                                    if (observableValue === undefined) {
                                        value._current = self[property];
                                    }
                                    self[property] = value;
                                }
                            }
                            else if (value !== undefined) {
                                // The control has a default value, the options value is not observable. This happens often in 'client' forms such as the control gallery.
                                self[property] = value;
                            }
                        }
                    }
                    else {
                        if ($dyn.isObservable(value)) {
                            // No default value and the options value is observable.
                            self[property] = value;
                        }
                        else {
                            // No default value and the options value is not observable. This does not happen for server form.
                            self[property] = value !== undefined ? value : self[property];
                        }
                    }
                    if (this.bindUpdate && $dyn.isObservable(self[property])) {
                        self[property].valueChanged.subscribe(this.onObservablePropChange, this);
                    }
                    // Always modify the data object to match the current property
                    data[property] = self[property];
                }
                var observablePropertyList = self._observablePropertyList;
                if (observablePropertyList) {
                    for (var i = 0, len = observablePropertyList.length; i < len; i++) {
                        property = observablePropertyList[i];
                        value = self[property];
                        if (!$dyn.isObservable(value)) {
                            self[property] = $dyn.observable(value);
                            if (this.bindUpdate) {
                                self[property].valueChanged.subscribe(this.onObservablePropChange, this);
                            }
                        }
                    }
                }
                if (this.bindUpdate && this.Children) {
                    this.Children.valueChanged.subscribe(this.onObservablePropChange, this);
                }
                this.parametersApplied = true;
            };
            /**
             * Toggles the $dyn.ui.Control.__updating observable.
             */
            Control.prototype.onObservablePropChange = function () {
                if (!$dyn.peek(this.__updating)) {
                    this.setUpdating(true);
                    this.setUpdating(false);
                }
            };
            /**
             * Keeps track of timeout ids that this control is scheduling.
             * Prevents the situation when control related operation is performed after control is disposed.
             *
             * @param callback The action to schedule
             * @param delay Time in milliseconds
             */
            Control.prototype.setTimeout = function (callback, delay) {
                var _this = this;
                if (!this._timeoutIds) {
                    this._timeoutIds = {};
                }
                var timeoutId = window.setTimeout(function () {
                    callback && callback.call(_this);
                    if (_this._timeoutIds) {
                        delete _this._timeoutIds[timeoutId];
                    }
                }, delay);
                this._timeoutIds[timeoutId] = timeoutId;
                return timeoutId;
            };
            /**
             * Raise an event on the element in this control.
             *
             * @param typeName Event type
             * @param options Passed to CustomEvent ctor
             */
            Control.prototype.RaiseEvent = function (typeName, options) {
                var evt = new CustomEvent(typeName, options);
                this.element.dispatchEvent(evt);
            };
            /**
             * Checks if focus can be set to the childELement within the context of the its root.
             * Makes an immediate or delayed call to form_SetFocus to set focus to the control.
             */
            Control.prototype.setFocus = function (childElement, root) {
                if (childElement) {
                    var childControl = $dyn.ui.getLiveControl(childElement);
                    var childControlName = childControl ? childControl.Name : childElement.getAttribute("data-dyn-controlname");
                    if (childControl && childControl !== this) {
                        // Prevent focus on disabled controls
                        if (childControl && !$dyn.value(childControl.Enabled)) {
                            $dyn.log.focus && $dyn.log.focus("Focus: Form(Form.Id: %s)->Focus prevented for disabled control name: %s", root.Id, childControlName);
                            return;
                        }
                        // If the control is already focused return.
                        if ($dyn.util.isControlFocused(childElement, root)) {
                            return;
                        }
                        var focusClass = childElement.getAttribute("data-dyn-focus");
                        // tslint:disable-next-line:triple-equals
                        if (childControl && $dyn.value(childControl.isContainer) && (focusClass == "" || focusClass === undefined)) {
                            childControl.setChildControlFocus();
                        }
                        if (root) {
                            // Delay setting focus to end of the browser stack frame. This is done to ensure that all tasks that result from on action have completed before focus is set.
                            root.elementToFocus = childElement;
                            root.elementToFocusName = childControlName;
                            $dyn.log.focus && $dyn.log.focus("Focus: Control->setFocus->Delay setting focus to - control name:' %s ' as a microTask", root.elementToFocusName);
                            if (!root.isSetControlFocusCalled) {
                                root.isSetControlFocusCalled = true;
                                $dyn.microTask(function () {
                                    $dyn.log.focus && $dyn.log.focus("Controls->setFocus->Execute micro task to set focus to a control '%s'.", root.elementToFocusName);
                                    $dyn.callFunction(root.form_setFocus, root, root.elementToFocus);
                                    root.elementToFocus = null;
                                    root.elementToFocusName = "";
                                    root.isSetControlFocusCalled = false;
                                });
                            }
                        }
                    }
                }
            };
            Control.prototype.createUpdatingObservable = function () {
                var _this = this;
                this.__updating = $dyn.observable(false);
                this.__updating.valueChanged.subscribe(function (updating) {
                    if (!$dyn.peek(updating)) {
                        if (_this.bindingTrigger) {
                            // If we have a binding trigger for this object then increment it in order to trigger a change for subscribers.
                            _this.bindingTrigger($dyn.peek(_this.bindingTrigger) + 1);
                        }
                    }
                });
            };
            return Control;
        }());
        ui.Control = Control;
        // Set default values on the prototype instead of as default property values so that they can be overridden by $dyn.ui.extendPrototype
        Control.prototype.Visible = true;
        Control.prototype.Skip = false;
        Control.prototype.Enabled = true;
        Control.prototype.AllowEdit = true;
        Control.prototype.Width = $dyn.layout.Size.content;
        Control.prototype.Height = $dyn.layout.Size.content;
        Control.prototype.IsViewMode = false;
        Control.prototype.AllowPersonalization = true;
        Control.prototype.Style = "";
        Control.prototype.PersistPersonalization = null;
        Control.prototype.ExecutePersonalizationCommand = null;
        Control.prototype.RequestEnhancedPreview = null;
        Control.prototype.CanHavePreview = false;
        Control.prototype.Shortcuts = {
            AvailableShortcuts: {
                Keys: { alt: true, shift: true, keyCode: $dyn.ui.KeyCodes.letterK },
                Handler: function (evt) {
                    if (this.showShortcutsHandler) {
                        this.showShortcutsHandler(evt.target);
                    }
                    else if (this.Shortcuts) {
                        // React components have shortcuts but don't derive from $dyn.ui.Control
                        $dyn.ui.Control.prototype.showShortcutsHandler.call(this, evt.target);
                    }
                },
                ShowToUser: false,
            },
        };
        Control.prototype.properties = {};
        $dyn.ui.addPropertiesToPrototype(Control.prototype, {
            ExtendedStyle: {
                attributeSetter: $dyn.ui.replaceCssClass,
                converter: $dyn.util.converters.notNullString,
                defaultValue: "",
                observable: true,
                serialize: true,
            },
        });
    })(ui = $dyn.ui || ($dyn.ui = {}));
})($dyn || ($dyn = {}));

//# sourceMappingURL=Control.js.map
